import React from 'react'

const AuthKeys = props => {
  let { keys, referenceNums, authorization_label } = props.auth_keys
  const cleanText = text => {
    if (typeof text === 'string')
      return text.replaceAll(/<[^>]*>/gim, '')
    else return text
  }


  return <div>
    <div className='legals__auth-key'>
      <ul className='legals__auth-keys-content'>
        {
          keys
            .map((key, index) => <li className='legals__auth-keys-item' key={index}>
              <span className='name'>{key.name}</span>
              <span className='value' dangerouslySetInnerHTML={{ __html: cleanText(key.value) }} />
            </li>)
        }
      </ul>
      <ul className='legals__references-content'>
        {
          referenceNums
            .map((reference, index) => <li className='legals__references-item' key={index}>
              <span className='name'>{reference.name}</span>
              <span className='value' dangerouslySetInnerHTML={{ __html: cleanText(reference.value) }} />
            </li>)
        }
      </ul>
    </div>
    {
      authorization_label.map((label, id) => <span key={id} className='name'>{label.name}</span>)
    }
  </div>
}

export default AuthKeys